import React, { ReactElement } from 'react';
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { DISCORD_URL, DOCS_URL, X_URL } from 'modules/common';
import { useTranslation } from 'modules/i18n';

import { translation } from './translation';

interface IFooterProps {
  className?: string;
}

export function Footer({ className }: IFooterProps): ReactElement {
  const { classes, cx } = useStyles();
  const { t, keys } = useTranslation(translation);

  return (
    <footer className={cx(classes.root, className)}>
      {t(keys.allRightsReserved)}

      <a
        className={classes.link}
        href={DOCS_URL}
        rel="noreferrer"
        target="_blank"
      >
        {t(keys.docs)}
      </a>

      <div className={classes.social}>
        <a
          className={classes.link}
          href={X_URL}
          rel="noreferrer"
          target="_blank"
        >
          {t(keys.x)}
        </a>

        <a
          className={classes.link}
          href={DISCORD_URL}
          rel="noreferrer"
          target="_blank"
        >
          {t(keys.discord)}
        </a>
      </div>
    </footer>
  );
}

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 12,
    color: alpha(theme.palette.secondary.contrastText, 0.5),
    margin: theme.spacing(16, 0, 8),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
  },

  social: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  link: {
    color: alpha(theme.palette.secondary.contrastText, 0.5),
    textTransform: 'uppercase',

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },

  disabled: {
    color: alpha(theme.palette.secondary.contrastText, 0.5),
    textTransform: 'uppercase',
  },
}));
